<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="病症" prop="illnessName">
                <a-input v-model="queryParam.illnessName" placeholder="请输入病症" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="患者类型" prop="patientType">
                 <a-select v-model="queryParam.patientType" placeholder="请选择患者类型" allow-clear>
                   <a-select-option :value="1">儿童</a-select-option>
                   <a-select-option :value="2">成人</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:choose:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:choose:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:choose:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:choose:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 推荐医生弹窗 -->
      <recommend-doctor-modal
        :visible.sync="recommendVisible"
        :currentChoose="currentChoose"
        @close="onRecommendClose"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="avatar" slot-scope="text, record">
          <img v-viewer v-if="record.avatar" :src="processImageUrl(record.avatar)"
               class="avatar" style="width: 100px;height: 100px; object-fit: cover; border-radius: 4px;" @error="handleImageError" />
          <a-icon v-else type="user" style="font-size: 80px; color: #ccc;" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleRecommend(record)" v-hasPermi="['user:choose:query']">
            <a-icon type="solution" />择医记录
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageChoose,listChoose, delChoose } from '@/api/user/choose'
import CreateForm from './modules/CreateForm'
import RecommendDoctorModal from './modules/RecommendDoctorModal'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'Choose',
  components: {
    CreateForm,
    RecommendDoctorModal
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 推荐医生弹窗
      recommendVisible: false,
      currentChoose: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        type: 4,
        range: null,
        cityProvince: null,
        name: null,
        patientType: null,
        sex: null,
        doctorNum: null,
        price: null,
        score: null,
        illnessId: null,
        illnessName: null,
        status: null,
        payType: null,
        payTime: null,
        isAllot: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return text === 1 ? 'ai择医' : text === 2 ? '自主择医' : text === 3 ? '人工择医' : '精准择医'
          }
        },
        {
          title: '择医范围',
          dataIndex: 'range',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if(text === 1){
              return '市'
            }else if (text === 2){
              return '省'
            }else if (text === 3){
              return '全国'
            }
          }
        },
        {
          title: '病症',
          dataIndex: 'illnessName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省/市',
          dataIndex: 'cityProvinceName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '患者姓名',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '患者类型',
          dataIndex: 'patientType',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text === 1) {
              return "儿童";
            } else if (text === 2) {
              return "成人";
            }
          }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text === 1) {
              return "男";
            } else if (text === 2) {
              return "女";
            }
          }
        },
        {
          title: '需要医师数量',
          dataIndex: 'doctorNum',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '医币数',
        //   dataIndex: 'price',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '积分数',
          dataIndex: 'score',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    processImageUrl,
    /** 图片加载错误处理 */
    handleImageError (e) {
      e.target.style.display = 'none'
      e.target.nextElementSibling.style.display = 'inline-block'
    },
    /** 查询择医记录列表 */
    getList () {
      this.loading = true
     pageChoose(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        nickname: undefined,
        illnessName: undefined,
        userId: undefined,
        type: 4,
        range: undefined,
        cityProvince: undefined,
        name: undefined,
        patientType: undefined,
        sex: undefined,
        doctorNum: undefined,
        price: undefined,
        score: undefined,
        illnessId: undefined,
        status: undefined,
        payType: undefined,
        payTime: undefined,
        isAllot: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 查看推荐医生记录 */
    handleRecommend (record) {
      this.currentChoose = record
      this.recommendVisible = true
    },
    /** 关闭推荐医生弹窗 */
    onRecommendClose () {
      this.recommendVisible = false
      this.currentChoose = null
    },
    /** 详情按钮操作 */
    handleDetail (record) {
      this.$refs.createForm.handleInfo(record)
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delChoose(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/choose/export', {
            ...that.queryParam
          }, `择医记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
